var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 11.7338C10.5907 11.7338 11.8801 10.4603 11.8801 8.88937C11.8801 7.31842 10.5907 6.04492 9.00012 6.04492C7.40954 6.04492 6.12012 7.31842 6.12012 8.88937C6.12012 10.4603 7.40954 11.7338 9.00012 11.7338Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 0L4.653 1.77778H1.8C0.81 1.77778 0 2.57778 0 3.55556V14.2222C0 15.2 0.81 16 1.8 16H16.2C17.19 16 18 15.2 18 14.2222V3.55556C18 2.57778 17.19 1.77778 16.2 1.77778H13.347L11.7 0H6.3ZM9 13.3333C6.516 13.3333 4.5 11.3422 4.5 8.88889C4.5 6.43556 6.516 4.44444 9 4.44444C11.484 4.44444 13.5 6.43556 13.5 8.88889C13.5 11.3422 11.484 13.3333 9 13.3333Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.203b8f68c40d20eda665737323a2d2df.svg";
export { ForwardRef as ReactComponent };